export default "__VITE_ASSET__B9Rn2qUP__"